<div>
  <a *showAuthed="currentUser" href="javascript:" (click)="inviteModal.show()">
    <i class="ti-email"></i>
    <span *ngIf="hasNotifications" class="badge bg-c-pink"></span>
  </a>

  <!-- Invite alerts modal -->
  <invite-alerts-modal
    #inviteModal
    [limit]="2"
    [config]="config"
    [currentUser]="currentUser"
    (confirmAlert)="alertUser($event)"
    [hideFooter]="true"
  >
  </invite-alerts-modal>
  <!-- Invite alerts modal -->
</div>
